import { SmIcon } from '@smiles/smiles-react-design-system';
import React from 'react';

export function Alert() {
  return (
    <div className="smls-optin__alert">
      <span className="smls-optin__alert-title">
        <SmIcon
          className="smls-optin__alert-icon smls-optin__icon--primary"
          name="info"
          size="small"
          type="round"
        />
        Fique atento!
      </span>
      <p className="smls-optin__alert-text">
        As milhas bônus são limitadas em 300.000 milhas por CPF ou Conta
        Família.
      </p>
    </div>
  );
}
